import angular from 'angular';
import IconDirective from './directives/icon/IconDirective';
import codepoints from 'json-loader!./directives/icon/generated/codepoints.json';

export default angular.module('edge.platform.widgets.icon', []).constant('GW_ICON_FONT_CODEPOINTS', codepoints).directive('gwIcon', IconDirective);


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/platform/widgets/icon/module.js
// module id = 1963
// module chunks = 0